import { authRepo } from '@porterin/booking-flow/src/auth/domain/repo/authRepo';
import { NetworkError } from '@porterin/booking-flow/src/auth/domain/types/errors';
import { LoginFormValues } from '@porterin/booking-flow/src/auth/domain/validations/LoginValidationSchema';
import { AuthModalVariant } from '@porterin/booking-flow/src/auth/view/components';
import { PrefillData } from '@porterin/booking-flow/src/auth/view/types/SignupModal';
import { User } from '@porterin/booking-flow/src/order-review/view/contexts/auth/AuthContext';
import { getTrackingCookieSafe } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import { Dispatch, SetStateAction } from 'react';

// TODO: find better way of handling too many arguments
export const handleLoginSubmit = async (
  data: LoginFormValues,
  is_mobile_updated: boolean,
  prefill: PrefillData | null,
  set_prefill: Dispatch<SetStateAction<PrefillData | null>>,
  set_current_auth_state: Dispatch<SetStateAction<AuthModalVariant>>,
  set_user: Dispatch<SetStateAction<User | null>>,
  set_error: (error: string) => void,
) => {
  const trackingId = getTrackingCookieSafe();

  set_user(prev => ({
    ...prev,
    mobile: data.phone,
    name: prefill?.name,
    requirementType: prefill?.requirement,
  }));

  const setAuthState = async () => {
    try {
      const isExists = await authRepo.checkExistOtp(trackingId, data.phone);
      prefill
        ? set_prefill(prev => ({ ...prev, mobile: data.phone }))
        : set_prefill(null);
      set_current_auth_state(isExists.status ? 'otp' : 'signup');
    } catch (error: NetworkError | any) {
      if ((error as NetworkError).type === 'NetworkError') {
        set_error(error.message);
      } else {
        set_error('Something went wrong');
      }
    }
  };

  if (is_mobile_updated) {
    try {
      const doesCustomerExist = await authRepo.checkCustomerExists(data.phone);
      if (doesCustomerExist.exists == true) {
        setAuthState();
      } else {
        if (doesCustomerExist.exists == false) {
          prefill
            ? set_prefill(prev => ({ ...prev, mobile: data.phone }))
            : set_prefill(null);
        }
        set_current_auth_state('signup');
      }
    } catch (error) {
      typeof error == 'string'
        ? set_error(error)
        : set_error('Something went wrong');
    }
  } else {
    setAuthState();
  }
};
